import { useNavigate } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { CHANGELOG } from '@/lib/changelog'

function ChangeLog() {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col h-screen" style={{ backgroundColor: '#12141D' }}>
      {/* Header */}
      <div className="flex-none pt-12 pb-2 px-6">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="w-10 h-10 rounded-full flex items-center justify-center"
            style={{ backgroundColor: '#1C1F2E' }}
          >
            <Icon icon="lucide:arrow-left" className="w-5 h-5 text-gray-300" />
          </button>
          <h1 className="text-xl font-bold text-white flex-1 text-center pr-10">更新说明</h1>
        </div>
      </div>

      {/* Entries */}
      <main className="flex-1 overflow-y-auto px-6 pt-4 pb-12 flex flex-col gap-5">
        {CHANGELOG.map((entry) => (
          <section key={entry.date} className="flex flex-col gap-2">
            <h2 className="text-xs font-bold text-gray-500 px-1 font-mono tracking-wider">
              {entry.date}
            </h2>
            <div className="rounded-2xl flex flex-col" style={{ backgroundColor: '#1C1F2E' }}>
              {entry.items.map((item, j) => {
                const isLast = j === entry.items.length - 1
                const isFix = item.type === 'fix'
                return (
                  <div
                    key={j}
                    className={`flex items-start gap-3 px-4 py-3 ${isLast ? '' : 'border-b border-[#2A2D3A]'}`}
                  >
                    <span
                      className={`text-[10px] font-bold rounded px-1.5 py-0.5 mt-0.5 flex-none ${
                        isFix
                          ? 'text-amber-300 bg-amber-300/10'
                          : 'text-emerald-400 bg-emerald-400/10'
                      }`}
                    >
                      {isFix ? '修复' : '新功能'}
                    </span>
                    <p className="text-sm text-gray-200 leading-relaxed flex-1">{item.text}</p>
                  </div>
                )
              })}
            </div>
          </section>
        ))}
      </main>
    </div>
  )
}

export default ChangeLog
